import { request } from '../../helpers/api/request';

export const deleteCity = async (id: number) => {
    const { data } = await request({
        url: `admin/cities/${id}`,
        method: 'DELETE',
    });

    return data;
};
